<template>
  <div id="google_button"></div>
</template>

<script>
export default {
  props: {
    price: {
      type: Number,
    },
  },

  mounted() {
    this.googlePayLoaded();
  },

  methods: {
    googlePayLoaded() {
      const paymentsClient = new window.google.payments.api.PaymentsClient({ environment: process.env.VUE_APP_GOOGLE_PAY_MODE });

      const paymentDataRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ['PAN_ONLY'],
            allowedCardNetworks: ['AMEX', 'DISCOVER', 'JCB', 'MASTERCARD', 'VISA'],
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: 'veritrans',
              gatewayMerchantId: process.env.VUE_APP_VERITRANS_MERCHANT_ID,
            },
          },
        }],
        merchantInfo: {
          merchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID,
          merchantName: 'ORIPALETTE',
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: this.price,
          currencyCode: 'JPY',
          countryCode: 'JP',
        },
      };

      const button = paymentsClient.createButton({
        onClick: () => {
          paymentsClient.loadPaymentData(paymentDataRequest).then((paymentData) => {
            this.$emit('defaultGooglePay', paymentData);
            // processPayment(paymentData);
          }).catch((err) => {
            console.error('Payment failed', err);
          });
        },
      });
      document.getElementById('google_button').appendChild(button);
    },
  },
};
</script>
